"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardAccordion = void 0;
var _react = require("react");
var _ = require("./..");
var _helpers = require("../../common/helpers");
var _CardAccordionCollapsible = _interopRequireDefault(require("./CardAccordionCollapsible"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["as", "className", "preHeading", "image", "heading", "decorator", "description", "labels", "button", "collapsibleTitle", "children", "slots", "slotProps", "collapsible"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className", "children"],
  _excluded6 = ["className", "children"],
  _excluded7 = ["className", "children"],
  _excluded8 = ["className"],
  _excluded9 = ["className"];
/**
 *
 * Card accordion - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/surfaces-cardaccordion) | [DSM](https://sharphealthcare.notion.site/Card-accordion-item-c708ee2902644eea8612766ade022916)
 *
 * @example
 *
 * <CardAccordion
 *  preHeading="This is a featured variant"
 *  image={{ alt: 'test', src: 'placeholder-image-16-9.jpg' }}
 *  title="My Card Accordion"
 *  decorator="$$"
 *  collapsible={{ title: 'This is expandable' }}>
 *  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi, suscipit.
 * </CardAccordion>
 *
 * <CardAccordion
 *  preHeading="This is a featured variant"
 *  image={{ alt: 'test', src: 'placeholder-image-16-9.jpg' }}
 *  title="My Card Accordion"
 *  decorator="$$" />
 */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CardAccordion = exports.CardAccordion = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _slotProps$preHeading, _slots$preHeading, _slotProps$preHeading2, _slots$image, _slotProps$image, _slots$heading, _slotProps$heading, _slots$decorator, _slotProps$decorator, _slots$description, _slotProps$descriptio, _slots$labelContainer, _slotProps$labelsCont, _slots$buttonContaine, _slotProps$buttonCont, _slots$button, _slotProps$preHeading3, _image$src;
  var as = props.as,
    className = props.className,
    preHeading = props.preHeading,
    _props$image = props.image,
    image = _props$image === void 0 ? {} : _props$image,
    heading = props.heading,
    decorator = props.decorator,
    description = props.description,
    labels = props.labels,
    button = props.button,
    collapsibleTitle = props.collapsibleTitle,
    children = props.children,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    collapsible = props.collapsible,
    rootProps = _objectWithoutProperties(props, _excluded);
  var Root = as !== null && as !== void 0 ? as : _.Card;

  // Preheading
  var hasPreheading = !!(preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps$preHeading = slotProps.preHeading) === null || _slotProps$preHeading === void 0 ? void 0 : _slotProps$preHeading.children);
  var PreHeading = (_slots$preHeading = slots.preHeading) !== null && _slots$preHeading !== void 0 ? _slots$preHeading : _.Typography;
  var defaultPreHeadingStyles = {
    variant: 'small-body-semibold',
    align: 'center'
  };
  var _ref = (_slotProps$preHeading2 = slotProps.preHeading) !== null && _slotProps$preHeading2 !== void 0 ? _slotProps$preHeading2 : {},
    preHeadingClassNameSlotProps = _ref.className,
    preHeadingSlotPropsRest = _objectWithoutProperties(_ref, _excluded2);
  var preHeadingProps = slots !== null && slots !== void 0 && slots.preHeading ? preHeadingSlotPropsRest : _objectSpread(_objectSpread({}, defaultPreHeadingStyles), preHeadingSlotPropsRest);

  // Image
  var Image = (_slots$image = slots.image) !== null && _slots$image !== void 0 ? _slots$image : 'img';
  var imagePropClassName = image.className,
    imagePropProps = _objectWithoutProperties(image, _excluded3);
  var _ref2 = (_slotProps$image = slotProps.image) !== null && _slotProps$image !== void 0 ? _slotProps$image : {},
    imageSlotPropsClassName = _ref2.className,
    imageSlotProps = _objectWithoutProperties(_ref2, _excluded4);
  var imageProps = slots.image ? imageSlotProps : _objectSpread(_objectSpread({}, imagePropProps), imageSlotProps);

  // heading
  var Heading = (_slots$heading = slots.heading) !== null && _slots$heading !== void 0 ? _slots$heading : _.Typography;
  var defaultHeadingProps = {
    variant: 'h4',
    as: 'h3'
  };
  var _ref3 = (_slotProps$heading = slotProps.heading) !== null && _slotProps$heading !== void 0 ? _slotProps$heading : {},
    headingClassNameSlotProps = _ref3.className,
    headingChildren = _ref3.children,
    restHeadingSlotProps = _objectWithoutProperties(_ref3, _excluded5);
  var headingProps = slots !== null && slots !== void 0 && slots.heading ? slotProps.heading : _objectSpread(_objectSpread({}, defaultHeadingProps), restHeadingSlotProps);

  // decorator
  var Decorator = (_slots$decorator = slots.decorator) !== null && _slots$decorator !== void 0 ? _slots$decorator : _.Typography;
  var defaultDecoratorStyle = {
    variant: 'body-semibold',
    align: 'right'
  };
  var _ref4 = (_slotProps$decorator = slotProps.decorator) !== null && _slotProps$decorator !== void 0 ? _slotProps$decorator : {},
    decoratorClassNameSlotProps = _ref4.className,
    decoratorChildren = _ref4.children,
    restDecoratorSlotProps = _objectWithoutProperties(_ref4, _excluded6);
  var decoratorProps = slots !== null && slots !== void 0 && slots.decorator ? slotProps.decorator : _objectSpread(_objectSpread({}, defaultDecoratorStyle), restDecoratorSlotProps);

  // description
  var Summary = (_slots$description = slots.description) !== null && _slots$description !== void 0 ? _slots$description : _.Typography;
  var _ref5 = (_slotProps$descriptio = slotProps.description) !== null && _slotProps$descriptio !== void 0 ? _slotProps$descriptio : {},
    descriptionClassNameSlotProps = _ref5.className,
    descriptionChildren = _ref5.children,
    restSummarySlotProps = _objectWithoutProperties(_ref5, _excluded7);

  // pills container
  var LabelContainer = (_slots$labelContainer = slots.labelContainer) !== null && _slots$labelContainer !== void 0 ? _slots$labelContainer : 'div';
  var _ref6 = (_slotProps$labelsCont = slotProps.labelsContainer) !== null && _slotProps$labelsCont !== void 0 ? _slotProps$labelsCont : {},
    labelContainerClassNameSlotProps = _ref6.className,
    restLabelContainerSlotProps = _objectWithoutProperties(_ref6, _excluded8);

  // button container
  var ButtonContainer = (_slots$buttonContaine = slots.buttonContainer) !== null && _slots$buttonContaine !== void 0 ? _slots$buttonContaine : 'div';
  var _ref7 = (_slotProps$buttonCont = slotProps.buttonContainer) !== null && _slotProps$buttonCont !== void 0 ? _slotProps$buttonCont : {},
    buttonContainerSlotPropsClassName = _ref7.className,
    buttonContainerSlotProps = _objectWithoutProperties(_ref7, _excluded9);
  var ButtonComponent = (_slots$button = slots.button) !== null && _slots$button !== void 0 ? _slots$button : _.Button;
  var buttonProps = slots.button ? slotProps.button : _objectSpread(_objectSpread({}, button), slotProps === null || slotProps === void 0 ? void 0 : slotProps.button);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, _objectSpread(_objectSpread(_objectSpread({}, !as && {
    variant: 'filled',
    padding: 'none'
  }), {}, {
    className: (0, _helpers.cn)('h-fit pb-6', hasPreheading && 'rounded-t-none', className),
    ref: ref
  }, rootProps), {}, {
    children: [hasPreheading && /*#__PURE__*/(0, _jsxRuntime.jsx)(PreHeading, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('bg-primary-100 py-2 leading-none -mx-0.5 -mt-[1.875rem] rounded-t-xl', preHeadingClassNameSlotProps)
    }, preHeadingProps), {}, {
      children: preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps$preHeading3 = slotProps.preHeading) === null || _slotProps$preHeading3 === void 0 ? void 0 : _slotProps$preHeading3.children
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-row items-center gap-x-4 mt-6 px-6",
      children: [((_image$src = image.src) !== null && _image$src !== void 0 ? _image$src : slotProps.image) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, _objectSpread({
        className: (0, _helpers.cn)('rounded-full h-15 w-15 object-cover', imageSlotPropsClassName)
      }, imageProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(Heading, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('flex-grow', headingClassNameSlotProps)
      }, headingProps), {}, {
        children: heading
      })), (decorator !== null && decorator !== void 0 ? decorator : decoratorChildren) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Decorator, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('font-bold', decoratorClassNameSlotProps)
      }, decoratorProps), {}, {
        children: decorator !== null && decorator !== void 0 ? decorator : decoratorChildren
      }))]
    }), (description !== null && description !== void 0 ? description : descriptionChildren) &&
    /*#__PURE__*/
    // `mr-4` cheats into right card gutter to give a little more wiggle room for content.
    (0, _jsxRuntime.jsx)(Summary, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('mt-4 ml-6 mr-4', descriptionClassNameSlotProps)
    }, restSummarySlotProps), {}, {
      children: description !== null && description !== void 0 ? description : descriptionChildren
    })), labels && /*#__PURE__*/(0, _jsxRuntime.jsx)(LabelContainer, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('flex flex-row flex-wrap mt-4 gap-x-3 gap-y-1 mx-6', labelContainerClassNameSlotProps)
    }, restLabelContainerSlotProps), {}, {
      children: labels.map(function (label) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Pill, _objectSpread({}, label));
      })
    })), button && /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonContainer, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('mt-5 mx-6', buttonContainerSlotPropsClassName)
    }, buttonContainerSlotProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonComponent, _objectSpread({
        size: "sm",
        width: "full"
      }, buttonProps))
    })), collapsibleTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardAccordionCollapsible["default"], _objectSpread(_objectSpread({
      title: collapsibleTitle,
      slots: slots,
      slotProps: slotProps
    }, collapsible), {}, {
      children: children
    }))]
  }));
});